import { Box, ListItemButton, Typography } from "@mui/material"
import { useParams } from "react-router"
import { navigateSequentialReview } from "authoring/routes/project/utilities/project-navigation"
import { useNumericSearchParam } from "lib/@hooks/use-search-param"

export function SequentialReviewSidebarItem({ schedule, currentScheduleId }) {
    const { projectId } = useParams()
    const [approved] = useNumericSearchParam("approved", 0)
    const [rejected] = useNumericSearchParam("rejected", 0)
    const isCurrent = schedule.id === currentScheduleId

    return (
        <ListItemButton
            selected={isCurrent}
            onClick={handleClick}
            sx={{
                px: 2,
                py: 1,
                borderBottom: 1,
                borderColor: "divider",
            }}
            data-cy="review-sidebar-schedule-item"
        >
            <Box sx={{ minWidth: 0 }}>
                <Typography variant="subtitle2" noWrap sx={{ fontWeight: isCurrent ? 700 : 400 }}>
                    {schedule.title}
                </Typography>
                <Typography variant="body2" color="text.secondary" noWrap>
                    #{schedule.code}
                </Typography>
            </Box>
        </ListItemButton>
    )

    function handleClick() {
        if (isCurrent) return
        navigateSequentialReview({ projectId, scheduleId: schedule.id, approved, rejected })
    }
}
